






































































import Vue from 'vue';
import Component from 'vue-class-component';
import { JsonObj } from 'vue-meta/types/vue-meta';

const Props = Vue.extend({
	props: {
		mois: {
			type: Number,
			default: 1
		}
	},
	data: function() {
		return {
			// Retourne l'index du slider (3 par défaut)
			index: this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()+'.aliment').length<3?this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()+'.aliment').length:3,
			// Retourne le nbre d'aliment contenu dans le slider
			nbrealiment: this.$t('components.santeenfant.trancheagealimentation.trancheage.mois'+this.mois.toString()+'.aliment').length
		};
	},
	methods: {
		// Calcul l'index quand l'utilisateur click sur la fleche next
		clickNextIcon: function() {
			let length = +this.nbrealiment;
			let indexSuivant = +this.index+3;
			if (indexSuivant<length) {
				this.index=indexSuivant;
			} else {
				this.index= length;
			}
		},
		// Calcul l'index quand l'utilisateur click sur la fleche prev
		clickPrevIcon: function() {
			let indexPrec = +this.index-3;
			if (indexPrec>3) {
				this.index=indexPrec;
			} else {
				this.index=3;
			}
		}
	}
});

@Component({})
export default class SliderAlimentation extends Props {
}
